import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  searchServices,
  selectServices,
  selectServicesMap,
} from 'app/service/Selectors';

export const selectServiceSearchQuery = state =>
  _.get(state, ['homepage', 'serviceSearch', 'query'], '');
export const selectServiceSearchSelected = state =>
  _.get(state, ['homepage', 'serviceSearch', 'selectedService']);

/**
 * Displayed on homepage picker when there is no search query applied
 */
export const selectDefaultHomepageServices = createSelector(
  [selectServicesMap],
  services => {
    if (_.size(services) === 0) {
      return [];
    }

    return _.compact([
      services.SlackDevAPI,
      services.GoogleSheetsV2API,
      services.TrelloAPI,
      services.GoogleMailV2API,
      services.AsanaDevAPI,
      services.FacebookV2API,
    ]);
  }
);

export const selectHomepageMatchedServices = searchServices(
  selectServiceSearchQuery,
  selectServices
);
